import React from 'react';
import { Box, Typography, Button, Container, Grid } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

const reasons = [
  'Your own branded domain & logo',
  'SEO-ready pages per property',
  'Zero commission to portals',
  'Direct leads — no middleman',
  'WhatsApp & email enquiry capture',
  'CRM auto-sync for all enquiries',
  'Virtual tour & 360° photo support',
  'Unlimited property listings',
  'Mobile-first responsive design',
  'Google Analytics integration',
];

const CTABanner = () => (
  <Box sx={{ py: { xs: 8, md: 10 }, position: 'relative', overflow: 'hidden', bgcolor: '#f8f7ff' }}>
    {/* Skewed divider */}
    <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, height: 80, background: 'linear-gradient(135deg, #1e1b4b 49%, #f8f7ff 50%)' }} />
    <Container maxWidth="lg" sx={{ pt: 8, position: 'relative', zIndex: 1 }}>
      <Grid container spacing={6} alignItems="center">
        <Grid item xs={12} md={6}>
          <Typography sx={{ color: '#4338ca', fontWeight: 700, fontSize: 13, letterSpacing: 2, mb: 2, fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase' }}>Everything Included</Typography>
          <Typography variant="h2" sx={{ fontWeight: 800, color: '#1e1b4b', mb: 3, fontFamily: "'Montserrat', sans-serif", fontSize: { xs: '1.9rem', md: '2.8rem' }, lineHeight: 1.2 }}>
            Launch Your Portal — We Handle Everything
          </Typography>
          <Typography sx={{ color: '#475569', fontSize: 16, mb: 4, fontFamily: "'Montserrat', sans-serif", lineHeight: 1.8 }}>
            We design, develop, and deploy your property listing website with all features ready from day one. You just add your listings and start getting leads.
          </Typography>
          <Grid container spacing={1.5}>
            {reasons.map((r, i) => (
              <Grid item xs={12} sm={6} key={i}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
                  <Box sx={{ width: 22, height: 22, borderRadius: '50%', bgcolor: '#4338ca', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <CheckIcon sx={{ color: '#fff', fontSize: 14 }} />
                  </Box>
                  <Typography sx={{ color: '#334155', fontSize: 14, fontFamily: "'Montserrat', sans-serif", fontWeight: 500 }}>{r}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={{ background: 'linear-gradient(135deg, #1e1b4b 0%, #4338ca 100%)', borderRadius: '24px', p: { xs: 4, md: 6 }, textAlign: 'center', boxShadow: '0 40px 100px rgba(67,56,202,0.3)' }}>
            <RocketLaunchIcon sx={{ fontSize: 60, color: '#a5b4fc', mb: 2 }} />
            <Typography variant="h3" sx={{ color: '#fff', fontWeight: 900, mb: 1.5, fontFamily: "'Montserrat', sans-serif", fontSize: '1.8rem' }}>Go Live This Week</Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.7)', mb: 4, fontFamily: "'Montserrat', sans-serif", lineHeight: 1.8 }}>Your branded property portal, ready in days — not months. Full onboarding support included.</Typography>
            <Button variant="contained" fullWidth size="large" sx={{ bgcolor: '#fff', color: '#1e1b4b', fontWeight: 800, py: 1.7, borderRadius: '14px', fontFamily: "'Montserrat', sans-serif", fontSize: 16, '&:hover': { bgcolor: '#c7d2fe' } }}>Request a Free Demo</Button>
            <Typography sx={{ color: 'rgba(255,255,255,0.5)', fontSize: 13, mt: 2, fontFamily: "'Montserrat', sans-serif" }}>No setup fee • Full support included</Typography>
          </Box>
        </Grid>
      </Grid>
    </Container>
  </Box>
);

export default CTABanner;
